import Navbar from "../components/layout/Navbar";
import Hero from "../components/home/Hero";
import ServiceGrid from "../components/home/ServiceGrid";
import HowItWorks from "../components/home/HowItWorks";
import Trust from "../components/home/TrustSection";
import CTA from "../components/home/CTA";
import Footer from "../components/home/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <ServiceGrid />
      <HowItWorks />
      <Trust />
      <CTA />
      <Footer />
    </>
  );
}